import React from 'react';
import styles from './ConstructionInfo.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../i18n';

const ConstructionInfo = ({ items }) => {
    return (
        <div className={styles['ConstructionInfo']}>
            <div className={styles['ConstructionInfo__Container']}>
                {items.map((item, i) => {
                    return <ConstructionItem key={i} {...item} />;
                })}
            </div>
        </div>
    );
};

const ConstructionItem = ({ type, text }) => {
    const heading = i18n.t(`constructionInfo.${type}`);

    const isLongString = text.length > 50;

    const iconClass = classNames(styles['ConstructionInfo__Icon'], {
        [styles[`ConstructionInfo__Icon--${type}`]]: type,
    });

    const textClass = classNames(styles['ConstructionInfo__Text'], {
        [styles['ConstructionInfo__Text--Long']]: isLongString,
    });

    return (
        <div className={styles['ConstructionInfo__Item']}>
            <div className={styles['ConstructionInfo__HeadingWrapper']}>
                <div className={iconClass} />

                {heading && (
                    <span className={styles['ConstructionInfo__Heading']}>
                        {heading}
                    </span>
                )}
            </div>
            {text && <span className={textClass}>{text}</span>}
        </div>
    );
};

ConstructionInfo.propTypes = {
    items: PropTypes.array,
};

ConstructionInfo.defaultProps = {
    items: [],
};

ConstructionItem.propTypes = {
    type: PropTypes.string,
    text: PropTypes.string,
};

ConstructionItem.defaultProps = {
    type: '',
    text: '',
};

export default ConstructionInfo;
